import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-material-minimum-quantity',
  templateUrl: './material-minimum-quantity.component.html',
  styleUrls: ['../modal.component.scss']
})

export class MaterialMinimumQuantityModalComponent {
  minimumMaterialQuantity: number;

  @Output() readonly responseChanged = new EventEmitter();

  emitTrue(): void {
    this.responseChanged.emit(this.minimumMaterialQuantity);
  }

  emitFalse(): void {
    this.responseChanged.emit(null);
  }
}